"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
function InputUnderlined(_a) {
    var value = _a.value, onTextChange = _a.onTextChange, placeholder = _a.placeholder, error = _a.error, information = _a.information, className = _a.className, required = _a.required, onValidate = _a.onValidate;
    var _b = __read((0, react_1.useState)(false), 2), isFocused = _b[0], setIsFocused = _b[1];
    var handleBlur = function () {
        setIsFocused(false);
        if (onValidate && required && !value.trim()) {
            onValidate(value);
        }
    };
    var handleInvalidInput = function (e) {
        // Prevent the default invalid behavior tooltip from showing
        e.preventDefault();
        if (onValidate) {
            onValidate(value);
        }
    };
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)("input-underlined-container ".concat(className), { 'input--filled': isFocused || value, 'input--error': error }) },
        react_1.default.createElement("input", { type: "text", value: value, onChange: function (e) { return onTextChange(e.target.value); }, onFocus: function () { return setIsFocused(true); }, onBlur: handleBlur, required: required, onInvalid: handleInvalidInput }),
        react_1.default.createElement("div", { className: "input-underlined-title" },
            placeholder,
            information && (react_1.default.createElement("div", { className: "eva-tooltip-container--center input-underlined-icon-container" },
                react_1.default.createElement("i", { className: "input-underlined-icon implioicons-question-mark-filled" }),
                react_1.default.createElement("div", { className: "eva-tooltip" }, information)))),
        react_1.default.createElement("div", { className: "input-underlined-error-container" }, error && react_1.default.createElement("span", null, error))));
}
exports.default = InputUnderlined;
